import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import VehicleHiringEntryForm from "./VehicleHiringEntryComponents/VehicleHiringEntryForm";
import { useAddVehicleHiringEntryMutation } from "store/services/vehicleHiringEntryApi";

const VehicleHiringEntryCreateScreen = () => {
    const navigate = useNavigate();
    const breadcrumbs = [
        { title: "Vehicle Hiring Entry", path: "/app/crm/vehicle-hiring-entry/list" },
        { title: "New Hiring Entry" },
    ];

    const [addVehicleHiringEntry, { isLoading }] = useAddVehicleHiringEntryMutation();

    const handleCreate = async (data) => {
        try {
            await addVehicleHiringEntry(data).unwrap();
            toast.success("Vehicle Hiring Entry successfully created!");
            navigate(`/app/crm/vehicle-hiring-entry/list?tab=Pending`);
        } catch (err) {
            toast.error(
                err?.data?.message ?? err?.message ?? "Couldn't create Entry!"
            );
        }
    };

    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
            <BreadcrumbLayout.Paper>
                <VehicleHiringEntryForm
                    isBusy={isLoading}
                    onSubmit={handleCreate}
                />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};

export default VehicleHiringEntryCreateScreen;